import {faDownload} from "@fortawesome/pro-solid-svg-icons/faDownload";
import {
    Button,
    FlexAlign,
    FlexGap,
    StackHorizontal,
    StackVertical,
    Tooltip,
    useTranslation
} from "@twigsby/frontend-framework";
import {useMailbox} from "../../../Providers/NewMailboxProvider";
import {useSite} from "../../../Providers/SiteInterfaceProvider";
import {MailItemThumbnails, MailPartTypeEnum} from "../../Mail/MailItemThumbnails";

const MailItemContents = () => {
    const { t } = useTranslation();
    const { setPdfViewer } = useSite();

    const { mailItemData} = useMailbox();

    return (
        <div className={'mail-item-contents'}>
            {mailItemData?.files && mailItemData?.files?.map((file, index: number) => {
                if (file.mailPart === MailPartTypeEnum["Mail-Contents"]) {
                    return (
                        <StackVertical>
                            <StackHorizontal
                                align={FlexAlign.Center}
                                gap={FlexGap.ExtraSmall}
                                extraClass={'mb-sm'}>
                                <h6 className={'pageantry-sub-heading text-left mb-0'}>{t('mailItem.labels.contents')} {mailItemData?.totalPages > 0 ? `- ${mailItemData?.totalPages.toString()} ${mailItemData?.totalPages === 1 ? 'Page' : 'Pages'}` : ''}</h6>

                                {!file.topupRequired && !file.isLocked && file.userFile && (
                                    <Tooltip content={t('actions.download')}>
                                        <Button
                                            icon={faDownload}
                                            iconOnly={true}
                                            squared={true}
                                            actionLink={{
                                                title: t('actions.download'),
                                                target: '_blank',
                                                url: file.userFile.linkToFile,
                                                download: file.userFile.fileName
                                            }}
                                        />
                                    </Tooltip>
                                )}
                            </StackHorizontal>

                            <MailItemThumbnails
                                mailType={MailPartTypeEnum['Mail-Contents']}
                                files={mailItemData.files}
                                largeThumbnail={true}
                                onClickCallback={(link: string) => setPdfViewer(true, link)}
                            />

                        </StackVertical>
                    )
                }

                return (
                    <StackVertical>
                        <StackHorizontal align={FlexAlign.Center}
                                         gap={FlexGap.ExtraSmall}
                                         extraClass={`mb-sm`}>
                            <h6 className={`pageantry-sub-heading text-left mb-0`}>{t('mailItem.labels.envelope')}</h6>

                            {!file.topupRequired && !file.isLocked && file.userFile && (
                                <Tooltip content={t('actions.download')}>
                                    <Button
                                        icon={faDownload}
                                        iconOnly={true}
                                        squared={true}
                                        actionLink={{
                                            title: t('actions.download'),
                                            target: '_blank',
                                            url: file.userFile?.linkToFile,
                                            download: file.userFile?.fileName
                                        }}
                                    />
                                </Tooltip>
                            )}
                        </StackHorizontal>

                        <MailItemThumbnails
                            mailType={MailPartTypeEnum['Mail-Envelopes']}
                            files={mailItemData.files}
                            largeThumbnail={true}
                            onClickCallback={(link: string) => setPdfViewer(true, link)}
                        />

                    </StackVertical>
                )
            })}
        </div>
    )
}

export {MailItemContents}
